import t from '../..';

function bottomBoxSupport(id) {
  const obj = {
    headline: [
      'Wie häufig benötigt die betroffene Person dabei schätzungsweise Unterstützung?',
      'Wie häufig benötigen Sie dabei schätzungsweise Unterstützung?',
    ],
    items: [
      {
        id: `bottomBoxSupport-1-${id}`,
        label: 'Mehrmals täglich und/oder in der Nacht',
      },
      {
        id: `bottomBoxSupport-2-${id}`,
        label: 'Einmal täglich',
      },
      {
        id: `bottomBoxSupport-3-${id}`,
        label: 'Mehrmals pro Woche',
      },
      {
        id: `bottomBoxSupport-4-${id}`,
        label: 'Maximal einmal pro Woche',
      },
    ],
  };
  return obj;
}

function bottomBoxActivities(id) {
  const obj = {
    headline: [
      'Möchten Sie oder andere Angehörige die Tätigkeiten übernehmen?',
      'Möchte Ihr Angehöriger die Tätigkeiten übernehmen?',
    ],
    items: [
      {
        id: `bottomBoxActivities-1-${id}`,
        label: 'Ja. Ich/wir möchte/n diese Tätigkeiten vollständig übernehmen.',
      },
      {
        id: `bottomBoxActivities-2-${id}`,
        label: 'Teilweise. Ich/wir möchte/n zusätzlich Hilfe durch einen Pflegedienst bekommen.',
      },
      {
        id: `bottomBoxActivities-3-${id}`,
        label:
          'Nein. Diese Tätigkeiten sollen/müssen über einen Pflegedienst sichergestellt werden.',
      },
    ],
  };
  return obj;
}

function switchButton(id = 0) {
  return {
    id: `switchButton-${id}`,
    activeLabel: 'Ja',
    inactiveLabel: 'Nein',
    checked: false,
  };
}

const content = [
  {
    id: 'overview-0',
    component: {
      name: 'Overview',
      props: {
        image: 'teaser-6',
        headline: ['Pflege & Betreuung'],
        copies: [
          'Es ist der Wunsch vieler Menschen, auch im Alter zuhause wohnen bleiben zu können. Gleichzeitig stellt die Pflege und Betreuung zuhause Umfeld und Angehörige oftmals vor nicht unerhebliche Herausforderungen.',
          'Wir möchten nun gern wissen, in welchen Bereichen und in welcher Häufigkeit die betroffene Person Unterstützung benötigt.',
        ],
      },
    },
  },
  {
    id: 'switcherRow-0',
    headline: [
      'Benötigt die betroffene Person leichte Unterstützung im Alltag?',
      'Benötigen Sie leichte Unterstützung im Alltag?',
    ],
    component: {
      name: 'SwitcherRow',
      props: {
        image: 'illu-handshake',
        headline: 'Leichte Unterstützung',
        bulletHead: 'Beispiele der leichten Unterstützung:',
        bullets:
          'Körperpflege, Waschen, Toilettengang, An- und Ausziehen, Essen und Trinken, etc.'.split(
            ','
          ),
        switchHeadline: t('cs.wizard.switcher.headline'),
        switchBtn: switchButton(),
        radioGroupHeadline: t('cs.wizard.radioGroupHeadline'),
        bottomBoxSupport: bottomBoxSupport('0'),
        bottomBoxActivities: bottomBoxActivities('0'),
      },
    },
  },
  {
    id: 'switcherRow-1',
    headline: [
      'Benötigt die betroffene Person Unterstützung in der Alltagsgestaltung?',
      'Benötigen Sie Unterstützung in der Alltagsgestaltung?',
    ],
    component: {
      name: 'SwitcherRow',
      props: {
        image: 'illu-user',
        headline: 'Alltagsgestaltung',
        bulletHead: 'Beispiele der Alltagsgestaltung:',
        bullets: 'Begleitung bei Arztbesuchen, Vorlesen, Unterhaltung, Spaziergänge, etc.'.split(
          ','
        ),
        switchHeadline: t('cs.wizard.switcher.headline'),
        switchBtn: switchButton(),
        radioGroupHeadline: t('cs.wizard.radioGroupHeadline'),
        bottomBoxSupport: bottomBoxSupport('1'),
        bottomBoxActivities: bottomBoxActivities('1'),
      },
    },
  },
  {
    id: 'switcherRow-2',
    headline: [
      'Benötigt die betroffene Person hauswirtschaftliche Versorgung im Alltag?',
      'Benötigen Sie hauswirtschaftliche Versorgung im Alltag?',
    ],
    component: {
      name: 'SwitcherRow',
      props: {
        image: 'illu-home',
        headline: 'Hauswirtschaft&shy;liche Versorgung',
        bulletHead: 'Beispiele der hauswirtschaftlichen Versorgung:',
        bullets:
          'Reinigung der Wohnung, Waschen von Wäsche, Einkaufen, Botengänge, Zubereitung von Mahlzeiten, etc.'.split(
            ','
          ),
        switchHeadline: t('cs.wizard.switcher.headline'),
        switchBtn: switchButton(),
        radioGroupHeadline: t('cs.wizard.radioGroupHeadline'),
        bottomBoxSupport: bottomBoxSupport('2'),
        bottomBoxActivities: bottomBoxActivities('2'),
      },
    },
  },
  {
    id: 'switcherRow-3',
    ignoringPriceCalculation: true,
    headline: [
      'Benötigt die betroffene Person medizinische Versorgung im Alltag?',
      'Benötigen Sie medizinische Versorgung im Alltag?',
    ],
    component: {
      name: 'SwitcherRow',
      props: {
        image: 'illu-heart',
        headline: 'Medizinische Versorgung',
        bulletHead: 'Beispiele der medizinischen Versorgung:',
        bullets:
          'Injektionen, Wundversorgung, Medikamentenvergabe, Wundliegegeschwür-Behandlung, Messen von Blutdruck und -zucker, Umgang mit Kathetern'.split(
            ','
          ),
        switchHeadline: t('cs.wizard.switcher.headline'),
        switchBtn: switchButton(),
        radioGroupHeadline: t('cs.wizard.radioGroupHeadline'),
        bottomBoxSupport: bottomBoxSupport('1'),
        bottomBoxActivities: bottomBoxActivities('1'),
      },
    },
  },
  {
    id: 'serviceToggles-0',
    ignoringPriceCalculation: true,
    headline: ['Welche Pflegeleistungen wurden bereits genehmigt?'],
    component: {
      name: 'ServiceToggles',
      props: {
        togglesPg1: [
          {
            headline: '1/2: Leistungen, die bei der Pflege und Betreuung zusätzlich entlasten',
            rows: [
              {
                id: 'entlastungsbetrag',
                service: 'Entlastungsbetrag',
                description:
                  'Geld zur Reduzierung eigener Kosten, für haushaltsnahe Dienstleistung etc.',
              },
            ],
          },
          {
            headline: '2/2: Produkte und Maßnahmen, die Ihr Leben zuhause erleichtern',
            rows: [
              {
                id: 'pflegehilfsmittel',
                service: 'Pflegehilfsmittel',
                description: 'Geld für Pflegehilfsmittel zum Verbrauch',
              },
              {
                id: 'hausnotruf',
                service: 'Hausnotruf',
                description: 'Geld für Hausnotrufsysteme',
              },
              {
                id: 'wohnumfeldverbesserungen',
                service: 'Wohnumfeldverbesserungen',
                description: 'Geld für Wohnraumanpassungen',
              },
            ],
          },
        ],
        toggles: [
          {
            headline:
              '1/3: Finanzielle Leistungen für die selbst organisierte Pflege und/oder den Pflegedienst',
            rows: [
              {
                id: 'pflegegeld',
                service: 'Pflegegeld',
                description: 'Geld für die selbst organisierte Pflege',
              },
              {
                id: 'pflegesachleistungen',
                service: 'Pflegesachleistungen',
                description: 'Geld für den Pflegedienst',
              },
              {
                id: 'kombinationsleistung',
                service: 'Kombinationsleistung aus Pflegegeld und Pflegesachleistungen',
                description: 'Geld für die pflegebedürftige Person und den Pflegedienst',
              },
            ],
          },
          {
            headline: '2/3: Leistungen, die bei der Pflege und Betreuung zusätzlich entlasten',
            rows: [
              {
                id: 'entlastungsbetrag',
                service: 'Entlastungsbetrag',
                description:
                  'Für genutzte Betreuungs- und Entlastungsleistungen im Alltag und zum Finanzieren von Eigenanteilen',
              },
              {
                id: 'kurzzeitpflege',
                service: 'Kurzzeitpflege',
                description: 'Kurzzeitige Unterbringung im Pflegeheim',
              },
              {
                id: 'verhinderungspflege',
                service: 'Verhinderungspflege',
                description:
                  'Kurzzeitige Betreuung zuhause, wenn pflegende Personen verhindert sind',
              },
              {
                id: 'tagesundnachtpflege',
                service: 'Tages- und Nachtpflege',
                description: 'Betreuung in einer Pflegeeinrichtung am Tag oder in der Nacht',
              },
            ],
          },
          {
            headline: '3/3: Produkte und Maßnahmen, die Ihr Leben zuhause erleichtern',
            rows: [
              {
                id: 'pflegehilfsmittel',
                service: 'Pflegehilfsmittel',
                description: 'Geld für Pflegehilfsmittel zum Verbrauch',
              },
              {
                id: 'hausnotruf',
                service: 'Hausnotruf',
                description: 'Geld für Hausnotrufsysteme',
              },
              {
                id: 'wohnumfeldverbesserungen',
                service: 'Wohnumfeldverbesserungen',
                description: 'Geld für Wohnraumanpassungen',
              },
            ],
          },
        ],
      },
    },
  },
];

export default content;
